import { Box, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { useRecoilValue } from 'recoil';
import DoseItem from '~/components/DoseItem/DoseItem';
import SelectableListItem from '~/components/SelectableListItem/SelectableListItem';
import { DoseMatrix } from '~/domain/patient/doseMatrix';
import useAvailableDoses from '~/hooks/dose/useAvailableDoses';
import { currentDoseState } from '~/state/atoms/dose/doseAtoms';
import { getDoseLabel } from '../doseUtils';

type DoseSelectionProps = {
    onSelect: (dose: DoseMatrix) => void;
};

export default function DoseSelection({ onSelect }: DoseSelectionProps) {
    const currentDose = useRecoilValue(currentDoseState);
    const availableDoses = useAvailableDoses(true);

    return (
        <Box display="grid">
            <Box px={1.5} pb={0.5}>
                <Typography fontSize={12} color="primary" fontWeight={500}>
                    <FormattedMessage id="selectDose" />
                </Typography>
            </Box>
            <Box display="flex" flexDirection="column">
                {availableDoses.map((dose) => {
                    const isActive =
                        currentDose?.dicomUid === dose.sopInstanceUID;
                    const label = getDoseLabel(
                        dose.label,
                        dose.item?.doseSummationType
                    );

                    return (
                        <SelectableListItem
                            key={dose.sopInstanceUID}
                            isSelected={isActive}
                            onClick={() => {
                                if (dose.item) {
                                    onSelect(dose.item);
                                }
                            }}
                            disabled={!dose.isLoaded}
                            sx={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                gap: 1,
                            }}
                        >
                            {dose.item ? (
                                <DoseItem dose={dose.item} label={label} />
                            ) : (
                                <Typography
                                    fontSize={12}
                                    noWrap
                                    sx={{ minWidth: 0 }}
                                >
                                    {label}
                                </Typography>
                            )}
                        </SelectableListItem>
                    );
                })}
            </Box>
        </Box>
    );
}
